module.exports = __webpack_public_path__ + "static/media/country_ad.12fba898.webp";